import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDoctors, removeDoctor } from "../redux/slices/doctorSlice";

function DoctorList() {
  const dispatch = useDispatch();
  const { doctors, loading, error } = useSelector((state) => state.doctors);

  React.useEffect(() => {
    dispatch(fetchDoctors());
  }, [dispatch]);

  const handleDelete = (id) => {
    dispatch(removeDoctor(id));
  };

  if (loading) return <div>Loading doctors...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <h2>Doctors</h2>
      {doctors.length === 0 ? (
        <p>No doctors found</p>
      ) : (
        <ul>
          {doctors.map((doctor) => (
            <li key={doctor.doctor_id}>
              <strong>{doctor.first_name} {doctor.last_name}</strong>
              <p>Email: {doctor.email}</p>
              <p>Plan ID: {doctor.subscription_plan_id}</p>
              <button onClick={() => handleDelete(doctor.doctor_id)}>Delete</button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default DoctorList;
